// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__tsMQA","svg":"Footer_svg__DWY92","navigation":"Footer_navigation__dpisM","footerContainer":"Footer_footerContainer__pyK-M","desktop":"Footer_desktop__xPr6t"};